// extracted by mini-css-extract-plugin
module.exports = {"actionTitle":"SampleExerciseSets_actionTitle__32iwC","exercisesCount":"SampleExerciseSets_exercisesCount__2_7IL"};